import {AxiosDownloadFileRequest, AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {RequestVisitorSearchCondition} from "../dto/RequestVisitorSearchCondition";
import {VisitRequestDto} from "../dto/VisitRequestDto";
import {RequestVisitorDto} from "../dto/RequestVisitorDto";
import {TENANT_ID} from "../../../constants/Profile";

export const RequestVisitorApi = {
    getLastVisitorInfo: async (idNumber: string, mobile: string, email: string) => {
        try {
            const params = new Map<string, string>();
            params.set('idNumber', idNumber);
            params.set('mobile', mobile);
            params.set('email', email);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/getLastVisitorInfo', params);

            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    fetchVisitorListByName: async (name: string,) => {
        try {
            const params = new Map<string, string>();
            params.set('name', name);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/getVisitorList', params);

            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    doCheckVisitorCardNumber: async (name: string, requestId: string) => {
        try {
            const params = new Map<string, string>();
            params.set('cardNumber', name);
            params.set('requestId', requestId ? requestId : "");
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/checkCardNumber', params);

            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    getAvailableVisitor: async (keywords: string) => {
        try {
            const params = new Map<string, string>();
            params.set('keywords', keywords);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/getAvailableVisitor', params);

            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    checkout: async (visitorId: string, accessCardNumber: string) => {
        try {
            const params = new Map<string, string>();
            params.set('visitorId', visitorId);
            params.set('accessCardNumber', accessCardNumber);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/checkout', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    queryMyRequestVisitors: async (body: RequestVisitorSearchCondition) => {
        try {
            const requestUrl = '/v1/vms/request/visitor/query/my/list';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    queryMyCreate: async (body: RequestVisitorSearchCondition) => {
        try {
            const params = new Map<string, string>();
            params.set('tenantId', TENANT_ID);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/query/my/createList', params);

            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    queryRequestVisitors: async (body: RequestVisitorSearchCondition) => {
        try {
            const requestUrl = '/v1/vms/request/visitor/query';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    queryRequestVisitorsNoTenant: async (body: RequestVisitorSearchCondition) => {
        try {
            const requestUrl = '/v1/vms/request/visitor/queryNoTenant';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    queryRequestVisitorsReport: async (body: RequestVisitorSearchCondition, reportClassify?: string) => {
        try {

            const params = new Map<string, string>();
            if (reportClassify) {
                params.set('reportClassify', reportClassify);
            }
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/query/report', params);
            const axiosResponse = await AxiosDownloadFileRequest.post(requestUrl, body);
            console.log(axiosResponse)
            const url = window.URL.createObjectURL(axiosResponse.data);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', 'VisitorListExportHistory.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getVisitorDetailById: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    /**
     * 获得访客访问记录列表
     */
    getVisitorAccessLogList: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/access/logs', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteVisitor: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/delete', params);

            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    checkinRegister: async (body: RequestVisitorDto) => {
        try {
            const axiosResponse = await AxiosRequest.post('/v1/vms/request/visitor/checkin/register', body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getPendingCheckinList: async () => {
        try {
            const requestUrl = '/v1/vms/request/visitor/pending/checkin/list';
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    checkinApprove: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/checkin/approve', params);

            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    checkinReject: async (id: string, body: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/checkin/reject', params);

            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    verifyVisitorPortrait: async (body: string) => {
        try {
            const requestUrl = "/v1/vms/request/visitor/portrait/verify";
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    checkLastTrainingDate: async (body: RequestVisitorDto) => {
        try {
            const requestUrl = '/v1/vms/request/visitor/checkLastTrainingDate';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    bindAccessCard: async (body: RequestVisitorDto) => {
        try {
            const requestUrl = "/v1/vms/request/visitor/bindAccessCard";
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    getLastVisitorInfoByWeOpenId: async (weOpenId: string) => {
        try {
            const params = new Map<string, string>();
            params.set('wxOpenId', weOpenId);
            params.set('tenantId', TENANT_ID);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/request/visitor/getLastVisitorInfoByWeOpenId', params);

            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
